import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {MatFormFieldModule} from '@angular/material/form-field';
import {provideNativeDateAdapter} from '@angular/material/core';
import {MatRadioModule} from '@angular/material/radio';
import {ProceduresService} from '../../../services/procedures/procedures.service';
import {CategoryService} from '../../../services/categories/categories.service';
import {ModesService} from '../../../services/modes/modes.service';
import {TypesService} from '../../../services/types/types.service';
import {ConnectedUser, InitialAuthService} from '../../../shared/auth/initial-auth.service';
import {CreateProcedureComponent} from "../create-procedure/create-procedure.component";
import {firstValueFrom, take} from 'rxjs';
import {EmargementsUsersService} from "../../../services/emargements-users/emargements-users.service";
import {MatDialog} from "@angular/material/dialog";
import {EmargeProcedureDialogComponent} from "../emarge-procedure-dialog/emarge-procedure-dialog.component";
import {EmargementUser} from "../../../models/emargementUsers/EmargementUsers";
import {UtilisateurService} from "../../../services/utilisateurs/utilisateur.service";
import {EtatsService} from "../../../services/etats/etats.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-modifier-procedure',
  templateUrl: './modifier-procedure.component.html',
  styleUrl: './modifier-procedure.component.scss',
  standalone: true,
  providers: [provideNativeDateAdapter(), CategoryService, ModesService, TypesService],
  imports: [
    CommonModule, MatTableModule, MatIconModule, MatSortModule, MatPaginatorModule, MatInputModule,
    MatCardModule, MatDividerModule, MatSelectModule, MatCheckboxModule, MatButtonModule,
    MatDatepickerModule, MatFormFieldModule, ReactiveFormsModule, MatRadioModule, CreateProcedureComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ModifierProcedureComponent {

  procedureForm: FormGroup;
  procedureId: any;
  procedure: any;
  procedureShowed = false;
  connectedUser: ConnectedUser | undefined;
  readOnly: boolean = false;
  openLogigramme: boolean = false;
  emargementUser: EmargementUser | undefined;

  public emargementData: {
    showEmargement: boolean;
    emargementUser: any;
  } = {
    showEmargement: false,
    emargementUser: null,
  };

  emargementForm: FormGroup;

  categories: any;
  modes: any;
  types: any;
  etats: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private proceduresService: ProceduresService,
    private emargementsUsersService: EmargementsUsersService,
    private utilisateurService: UtilisateurService,
    private initialAuthService: InitialAuthService,
    private etatService: EtatsService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private titleService: Title
  ) {
    this.procedureForm = this.formBuilder.group({
      isPOE: ['IOE'],
      mnemonique: ['', Validators.required],
      mnemoniqueRef: [''],
      titre: ['', Validators.required],
      version: ['', Validators.required],
      tags: [''],
      dateDebutValidite: [''],
      dateFinValidite: [''],
      category: ['', Validators.required],
      mode: ['', Validators.required],
      type: ['', Validators.required],
      etat: ['', Validators.required],
      annexes: ['']
    });

    this.emargementForm = this.formBuilder.group({
      emargementConfirmed: [false],
    });
  }

  async ngOnInit(): Promise<void> {
    this.procedureId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      if (params['readOnly']) {
        this.readOnly = true;
      }

      if(params['openLogigramme']) {
        this.openLogigramme= true
      }
    });
    if (this.procedureId) {
      try {
        this.connectedUser = await firstValueFrom(this.initialAuthService.connectedUser$);
        this.utilisateurService.getUsers({mail: this.connectedUser?.mail})
          .pipe(take(1))
          .subscribe(async (response: any) => {
            const user = response.data[0];
            const exist = user.profils.some((profil: any) => profil.id_application === 2);
            if (user && exist) {
              try {
                const emargementUser = await firstValueFrom(this.emargementsUsersService.getEmargementUsers({procedure_id: this.procedureId, user_id: user.id}));
                if (emargementUser && emargementUser.data.length > 0) {
                  console.log('emarged', emargementUser.data[0].emarged);     
                  this.emargementUser = emargementUser.data[0];
                }
                await this.loadProcedure(this.procedureId);

              } catch (error) {
                console.error('Error fetching emargementUser', error);
              }
            }
          });

      } catch (error) {
        console.error('Error loading emargementUser', error);
      }

    } else {
      await this.router.navigate(['liste-procedures']);
    }
  }

  async loadProcedure(id: string): Promise<void> {
    try {
      const procedure = await firstValueFrom(this.proceduresService.getProcedureById(id));
      if (procedure) {
        this.procedure = procedure.data;
        this.titleService.setTitle('Procédure : ' + this.procedure.mnemonique);
        this.procedureShowed = true;
        this.cdr.markForCheck();
        console.log('emargementUser', this.emargementUser);

        if (this.emargementUser && !this.emargementUser?.emarged) {
          this.emargementData = {
            showEmargement: true,
            emargementUser: this.emargementUser,
          };
        }
      }
    } catch (error) {
      console.error('Error loading procedure', error);
    }
  }

  onProcedureModified(): void {
    if (this.emargementData?.emargementUser?.id) {
      this.emargementsUsersService
        .updateEmargementUser(this.emargementData.emargementUser.id, { emarged: false })
        .subscribe({
          next: () => {
            console.log("Le flag 'emarged' a été mis à jour à false.");
          },
          error: (error) => {
            console.error("Erreur lors de la mise à jour du flag 'emarged'", error);
          },
        });
    }
  }

  onEmargementValidated(): void {
    if (this.emargementData.emargementUser) {
      this.emargementsUsersService.updateEmargementUser(this.emargementData.emargementUser.id, { emarged: true })
        .subscribe({
          next: () => {
            console.log("Émargement enregistré");
          },
          error: (error) => {
            console.error("Erreur lors de l'enregistrement de l'émargement", error);
          },
        });
    }
  }

  // async loadProcedure_emargement_dialog_legacy(id: string): Promise<void> {
  //   try {
  //     const procedure = await firstValueFrom(this.proceduresService.getProcedureById(id));
  //     if (procedure) {
  //       this.procedure = procedure.data;
  //       this.procedureShowed = true;
  //       this.cdr.markForCheck();
  //       console.log('emargementUser', this.emargementUser);
  //       const etat = await firstValueFrom(this.etatService.getEtatById(this.procedure.etat?.id)).then((res: any) => res.data);

  //       if (this.emargementUser && !this.emargementUser?.emarged) {
  //         const dialogRef = this.dialog.open(EmargeProcedureDialogComponent, {
  //           width: '650px',
  //           height: '270px',
  //           data: {mnemonique: this.procedure.mnemonique}
  //         });

  //         console.log('connectedUser', this.connectedUser);
  //         const currentUser = await firstValueFrom(this.utilisateurService.getUsers({mail: this.connectedUser?.mail}));
  //         console.log('currentUser', currentUser);

  //         dialogRef.afterClosed().subscribe(async result => {
  //           if (result) {
  //             try {
  //               await firstValueFrom(this.emargementsUsersService.updateEmargementUser(this.emargementUser?.id!, {emarged: true}));
  //             } catch (error) {
  //               console.error('Error updating emargementUser', error);
  //             }
  //           } else {
  //             console.log(result);
  //             console.log("EMARGEMENT");
  //             this.router.navigate(['liste-procedures']);
  //           }
  //         });
  //       }

  //     }
  //   } catch (error) {
  //     console.error('Error loading procedure', error);
  //     this.router.navigate(['liste-procedures']);
  //   }
  // }
}
